import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@4.3.0@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-iphone1",
  "use": "icon-iphone1-usage",
  "viewBox": "0 0 17 26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 17 26\" id=\"icon-iphone1\">\n\n<g>\n\t<path class=\"st0\" d=\"M14.7,0H2.3C1,0,0,1,0,2.3v21.3C0,25,1,26,2.3,26h12.4c1.3,0,2.3-1,2.3-2.3V2.3C17,1,16,0,14.7,0z M2.3,1.2\n\t\th12.4c0.6,0,1.1,0.5,1.1,1.1v1H1.2v-1C1.2,1.7,1.7,1.2,2.3,1.2z M1.2,4.6h14.6v15.3H1.2V4.6z M14.7,24.8H2.3\n\t\tc-0.6,0-1.1-0.5-1.1-1.1v-2.6h14.6v2.6C15.8,24.3,15.3,24.8,14.7,24.8z\" />\n\t<path class=\"st0\" d=\"M6.3,2.5h4.3c0.2,0,0.4-0.2,0.4-0.4s-0.2-0.4-0.4-0.4H6.3c-0.2,0-0.4,0.2-0.4,0.4S6.1,2.5,6.3,2.5z M7,23\n\t\tc0,0.6,0.3,1.1,0.8,1.3c0.5,0.3,1.1,0.3,1.6,0c0.5-0.3,0.8-0.8,0.8-1.3c0-0.9-0.7-1.6-1.6-1.6S7,22.1,7,23z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/iphone1.svg
// module id = H2eZ
// module chunks = 69